<template>
    <SwLayout>
        <div class="dm-wizard-field" v-if="presentation && presentation.content">
            <TinyMce
                v-model="presentation.content.description"
                toolbar="bold italic underline"
                :purifyContent="true"
                @change="validateAndSave()"
            />

            <WordCountWidget :word_count="wordCount" recommended_length="300" />
        </div>
    </SwLayout>
</template>

<script>
import TinyMce from "@shared/TinyMce.vue";
import WordCountWidget from "@shared/WordCountWidget.vue";
import { validationMixin } from "@/mixins/validationMixin.js";
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapWritableState, mapActions } from "pinia";
import { getDistinctWordsCountInString } from "@/utilities/utilities.js";

export default {
    mixins: [validationMixin],

    components: { TinyMce, WordCountWidget },

    data() {
        return {
            minLength: 1, // words. NB: I left it at 1 just so the 'Next' button is still disabled when first loading the page.
        };
    },

    computed: {
        ...mapWritableState(useSubmissionWizardStore, [
            "presentation",
            "bottom_navigation_rules",
        ]),

        wordCount() {
            if (!this.presentation) return 0;
            if (!this.presentation.content) return 0;
            return this.getDistinctWordsCountInString(this.presentation.content.description);
        },
        isValid() {
            return this.wordCount >= this.minLength;
        },
    },

    methods: {
        ...mapActions(useSubmissionWizardStore, ["savePresentation"]),

        getDistinctWordsCountInString,

        validateAndSave() {
            if (this.isValid) this.savePresentation();
        },
    },
};
</script>
